import { Howl } from 'howler';
import voData from '../audio/vo.json';
import { detectDevice } from './utils/device-detection';

// Resume audio context after being suspended
// https://snyk.io/advisor/npm-package/howler/functions/howler.Howler.ctx

const spriteVo = Object.keys(voData.spritemap).reduce((acc, key) => {
  if (key !== 'silence') {
    const { start, end } = voData.spritemap[key];
    acc[key] = [start * 1000, end * 1000 - start * 1000];
  }
  return acc;
}, {});

const getSrc = (pth) => {
  return [`${pth}.m4a`, `${pth}.mp3`];
};

const createHowlerVo = () => {
  return new Howl({
    preload: true,
    src: getSrc(PBS_WATCH ? 'http://localhost:3000/audio/vo' : `${siteData.resourcesPath}frontend/audio/vo`),
    autoplay: false,
    loop: false,
    volume: 0.5,
    pool: 3,
    sprite: spriteVo,
  });
};

let howlerVo = null;
let currentPlayingId = 'null';
const getHowlerVo = () => {
  if (!howlerVo) {
    howlerVo = createHowlerVo();
  }
  addFocusEventListener();
  return howlerVo;
};

const howlerVoPlayer = {
  play: function (key, vol = 0.5) {
    if (key) {
      const h = howlerVo;
      const id = h.play(key);
      currentPlayingId = id;
      h.volume(vol, id);
    }
  },
  fade: function () {
    const h = howlerVo;
    h.fade(1, 0, 300, currentPlayingId);
  },
  isPlaying: function () {
    const h = howlerVo;
    return h.playing();
  },
};

export const playVo = (key, fromClick = false, volume = 0.5) => {
  if (detectDevice() === 'mobile') return;

  if (!howlerVo) {
    getHowlerVo();
  }

  if (Howler?.ctx?.state === 'running' || false) {
    // if playing : fade out current vo
    howlerVoPlayer.isPlaying() && howlerVoPlayer.fade();
    howlerVoPlayer.play(key, volume);
  }
};

const addFocusEventListener = () => {
  window.addEventListener(
    'focus',
    function (event) {
      setTimeout(function () {
        howlerVo &&
          Howler.ctx.resume().then((e) => {
            console.log('Howler.ctx.resume');
          });
      }, 1000);
    },
    false
  );
};
